const domainRegex = /http[s]*:\/\/[www.]*ritual\.com[/]?/;

module.exports = {
  domainRegex,
};
